<script lang="ts">
  import Spacer from "@/components/spacer.svelte";

  import { Col, Container, Row } from "sveltestrap";

  const entities = [
    ["반딧불이 소개", "/bandiburri/welcome"],
    ["제품소개", "/service/product"],
    ["미디어", "/board/list/news"],
    ["설치사례", "/board/list/portfolio/garden"],
  ];
</script>

<Container fluid>
  <div class="mainview text-center">
    <Spacer size="5rem" />
    <h1>반딧불이는</h1>
    <Spacer size="1rem" />
    <div>
      사장님들이 농장에 없어도 가능한 시스템들을 구축하고 있으므로,
      <br />추후 자동예측을 통해 삶 속의 여유를 제공하겠습니다.
    </div>
    <Spacer size="2rem" />
    <div style="margin:auto; width:60%;">
      <Row>
        {#each entities as item, index}
          <Col xs="12" sm="3">
            <a href={item[1]}
              ><img
                alt="{item[0]} 아이콘"
                src="/images/main/s4_{index + 1}.png"
              /></a
            >
            <h3>{item[0]}</h3>
          </Col>
        {/each}
      </Row>
    </div>
    <Spacer size="5rem" />
  </div>
</Container>

<style lang="scss">
  img {
    transition: all 0.3s;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  img:hover {
    opacity: 0.8;
  }

  .mainview {
    background-image: url("/images/main/s4_bg.png");
    background-size: cover;
  }
</style>
